export function getOperatingSystem() {
  if (window.navigator.userAgent.indexOf('Win') != -1) return 'Windows'
  if (window.navigator.userAgent.indexOf('Mac') != -1) return 'MacOS'
  if (window.navigator.userAgent.indexOf('X11') != -1) return 'UNIX'
  if (window.navigator.userAgent.indexOf('Linux') != -1) return 'Linux'
}
